import Vue from 'vue'
import Vuex from 'vuex'
import basicMutations from './store/basicMutations'
import citationActions from './store/footnotesActions'



Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    footnoteApiResponse: [],
    textForApiCall: '',
    visualizerView: false,
    minRange: 22,
    maxRange: 10000,
    data: [],
    allResults: [],
    talmudResults: [],
    mishnaResults: [],
    tanakhResults: [],
    selectedResults: [],
    verseForChapter: [],
    visualizerResults: '',
    visualizerModes: ['tanakh', 'talmud', 'mishna'],
    chapterResults: '',
    mode: -1,
    noResults: false,
    higherResults: false,
    lowerResults: false,
    extTanakhRes: 0,
    extTalmudRes: 0,
    footnotesComplete: false,
    serverError: null,
    directMatch: false
  },
  mutations: {
    ...basicMutations,

  },
  actions: {
    ...citationActions,

  }
})



export default store
